import {
  agePrint,
  separateDateTime,
  capitalizeFirstLetter,
  getPatientIdForDoctor,
} from '../../../utils/helpers';
import { Row, Col, Button } from 'react-bootstrap';
// import profileImg from '../../../assets/images/profile.svg';
import avatarMale from '../../../assets/images/avatar_male.jpeg';
import avatarFemale from '../../../assets/images/avatar_female.jpeg';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useGetRequest } from '../../../hooks/useGetRequest';
import { usePostRequest } from '../../../hooks/usePostRequest';
import AddPatientInfo from '../modals/addPatientInfo';
import { useValidation } from '../../../hooks/validationHooks/useValiation';
import { appointmentSchema } from '../../../validationSchemas/appointment.validation';
import { toast } from 'react-toastify';
import moment from 'moment';

const PatientHistoryLeft = ({
  patientData,
  prescriptions,
  generalExamination,
  lastOnExamination,
  lastAppointment,
  lastPrescriptionId,
}) => {
  console.log('lastOnExamination: ', lastOnExamination);
  const [imageContent, setImageContent] = useState('');
  // for patient edit modal
  const [phoneNumber, setPhoneNumber] = useState('');
  const [backendError, setBackendError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOnExamination, setSelectedOnExamination] = useState({});

  const [patientPicture, setPatientPicture] = useState(null);
  const [patientInfo, setPatientInfo] = useState({});
  const [patientId, setPatientId] = useState('');
  const [isOpenCamera, setIsOpenCamera] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [errors, setErrors] = useState({});
  const [loadingStatus, setLoadingStatus] = useState(false);

  const [appointmentInfo, setAppointmentInfo] = useState({});
  const [appointmentDateTime, setAppointmentDateTime] = useState('');
  const [visitType, setVisitType] = useState('new');
  const [visitationFee, setVisitationFee] = useState('');
  const [patientType, setPatientType] = useState('new');
  const [generalExaminationNew, setGeneralExaminationNew] = useState({});
  const [infoModal, setInfoModal] = useState(false);

  const validation = useValidation;

  const userInfo = useSelector((state) => state.authReducer.data);
  const activeOrganization = useSelector(
    (state) => state.orgReducer.organization,
  );
  const activeDoctor = useSelector(
    (state) => state.doctorsOfAssistantReducer.activeDoctor,
  );
  //end of patient edit modal

  const patientSettings = useSelector(
    (state) => state?.prescriptionReducer?.prescriptionInfo?.patientSettings,
  );
  const ageProperties = patientSettings?.items?.find(
    (item) => item.name === 'age',
  );
  let { unitProperties } = ageProperties || {};
  const lastPrescription = prescriptions?.length ? prescriptions[0] : null;

  const countTotalItems = () => {
    return prescriptions?.reduce(
      (total, data) => {
        total.chiefComplain += data?.chiefComplains?.length || 0;
        total.diagnosis += data?.diagnoses?.length || 0;
        total.investigation += data?.investigations?.length || 0;
        total.advice += data?.advices?.length || 0;
        total.medicine += data?.medicines?.length || 0;
        total.followUp += data?.followUps?.length || 0;
        return total;
      },
      {
        chiefComplain: 0,
        diagnosis: 0,
        investigation: 0,
        advice: 0,
        medicine: 0,
        followUp: 0,
      },
    );
  };

  const { isLoading: isGetImageLoading, refetch: getImageLoad } = useGetRequest(
    `getSignatureContent-${patientData.id}`,
    `auth-patient/patient-profile-picture-for-doctor/${patientData.id}`,
    (data) => {
      setImageContent(data);
    },
    (e) => {
      console.log(e);
    },
  );

  useEffect(() => {
    console.log('lastOnExamination: ', lastOnExamination);
    countTotalItems();
    getImageLoad();
    setPatientInfo({ ...patientData });
    setSelectedOnExamination({ ...lastOnExamination });
    setAppointmentInfo({ ...lastAppointment });
  }, [lastOnExamination, patientData, lastAppointment]);

  const { isPatientLoading, mutate: submitUser } = usePostRequest(
    'prescriptions/update-patient-with-general-examination',
    {
      name: patientInfo.name,
      //dob: ageOrDob ? dob : ageConvertToDateTime(dob),
      dob: patientInfo.dob,
      phoneNumber: patientInfo.phoneNumber
        ? patientInfo.phoneNumber
        : phoneNumber,
      gender: patientInfo.gender ? patientInfo.gender : 'male',
      address: patientInfo?.patientDetails?.address,
      email: patientInfo?.email,
      appointmentDateTime: appointmentDateTime,
      visitType: visitType,
      serialNumber: patientInfo?.serialNumber,
      fee: parseInt(visitationFee),
      generalExaminations: selectedOnExamination?.generalExaminations,
      nid: patientInfo?.patientDetails?.nid,
      reference_by: patientInfo?.patientDetails?.reference_by,
      registration_no: patientInfo?.patientDetails?.registration_no,
      disease: patientInfo?.patientDetails?.disease,
      image: patientInfo?.image ? patientInfo?.image : null,
      doctorId: userInfo.id,
      patientId: patientInfo.id,
      appointmentId: appointmentInfo.id,
      prescriptionId: lastPrescriptionId,
      organizationId: activeOrganization.id,
      patientType: patientType,
    },
    (data) => {
      toast.success(data.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    },
    (error) => {
      setLoadingStatus(false);
      setBackendError(error.message);
    },
  );

  const handleSubmit = () => {
    console.log('working on fucntion....');
    setLoadingStatus(true);
    const { isValid, errors } = validation(
      {
        ...patientInfo,
        birthDate: patientInfo?.dob,
        appointmentDateTime: '2025-05-05 5:30 am', //as placeholder, no meaning of appointment date time
      },
      appointmentSchema,
    );
    if (isValid) {
      console.log('scucess submit');
      console.log('data detais; ', selectedOnExamination?.generalExaminations);
      submitUser();
    }
    {
      if (Object?.keys(errors)?.length !== 0) {
        setErrors(errors);
        setLoadingStatus(false);
      }
    }
  };

  const getPatientGender = () => {
    if (patientData?.gender && patientData?.gender === 'male') return 'Male';
    else if (patientData?.gender && patientData?.gender === 'female')
      return 'Female';
    else if (patientData?.gender) return 'Others';
    else return 'n/a';
  };

  const getAvatarImage = () => {
    if (imageSrc) return imageSrc;
    else if (patientPicture) return patientPicture;
    else if (patientInfo?.gender === 'female') return avatarFemale;
    else return avatarMale;
  };

  return (
    <>
      <div className="card shadow d-flex flex-column align-items-center justify-content-between mt-3">
        {/* <div
          className="edit-patient-link"
          onClick={() => setInfoModal(!infoModal)}
        >
          <i className="fa fa-user-edit" /> Edit
        </div> */}
        {imageContent === '' || isGetImageLoading ? (
          <img
            className="patient-img rounded-circle mt-3"
            src={
              patientData?.gender === 'female'
                ? getAvatarImage()
                : getAvatarImage()
            }
            alt="Avatar"
          />
        ) : (
          <img
            src={imageContent}
            className="patient-img rounded-circle mt-3"
            alt="Avatar"
          />
        )}
        <div className="patient-name">{patientData?.name}</div>
        {/* <div className="patient-phone-number">{patientData?.phoneNumber}</div> */}
        <div className="patient-email light-blue-color">
          {patientData?.email}
        </div>
        <div className="patient-pid mt-2">
          <span>Patient ID:</span>
          {getPatientIdForDoctor(patientData?.patientIdForDoctor, userInfo)}
        </div>
        <div className="patient-age">
          <span>Age:</span>
          {agePrint(separateDateTime(patientData?.dob), unitProperties)}
        </div>

        <button
          className="small-btn mt-2 mb-3"
          onClick={() => setInfoModal(!infoModal)}
        >
          Edit Profile
        </button>
      </div>

      {/* <hr className="mb-0" />
      <Row>
        <Col className="m-2">
          <Row className="summary-box">
            <Col>
              <div className="pt-1">Gender</div>
              <div className="pt-1 font-weight-bold">
                {capitalizeFirstLetter(patientData?.gender)}
              </div>
            </Col>
            <Col>
              <div className="pt-1">Age</div>
              <div className="pt-1 font-weight-bold">
                {agePrint(separateDateTime(patientData?.dob), unitProperties)}
              </div>
            </Col>
          </Row>
          <Row className="summary-box">
            <Col>
              <div className="pt-1">Height</div>
              <div className="pt-1 font-weight-bold">
                {generalExaminationNew?.heightInfo?.feet}
                {generalExaminationNew?.heightInfo?.inch
                  ? '.' + generalExaminationNew?.heightInfo?.inch
                  : ''}{' '}
                {generalExaminationNew?.heightInfo?.heightUnit}
              </div>
            </Col>
            <Col>
              <div className="pt-1">Weight</div>
              <div className="pt-1 font-weight-bold">
                {generalExaminationNew?.weightInfo?.weight}{' '}
                {generalExaminationNew?.weightInfo?.weightUnit}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="m-1 summary-box">
        <Col>
          <div className="pt-1">Total Appointments</div>
          <div style={{ fontSize: '24px' }}>{prescriptions?.length}</div>
        </Col>
      </Row>
      <Row>
        <Col className="ml-1 mr-1 mb-1">
          <div className="text-center font-weight-bold">
            Summary of prescriptions
          </div>
          <Row className="summary-box">
            <Col>
              <div className="value">{countTotalItems()?.chiefComplain}</div>
              <div className="item">Chief Complain</div>
            </Col>
            <Col>
              <div className="value">{countTotalItems()?.diagnosis}</div>
              <div className="item">Diagnosis</div>
            </Col>
            <Col>
              <div className="value">{countTotalItems()?.medicine}</div>
              <div className="item">Rx</div>
            </Col>
          </Row>
          <Row className="summary-box">
            <Col>
              <div className="value">{countTotalItems()?.followUp}</div>
              <div className="item">Follow Up</div>
            </Col>
            <Col>
              <div className="value">{countTotalItems()?.investigation}</div>
              <div className="item">Investigation</div>
            </Col>
            <Col>
              <div className="value">{countTotalItems()?.advice}</div>
              <div className="item">Advice</div>
            </Col>
          </Row>
        </Col>
      </Row> */}

      <div className="card shadow d-flex flex-column align-items-center justify-content-between mt-4 mb-3 black p-2">
        <span className="mb-2 text-center" style={{ fontWeight: 'bold' }}>
          Total Visits
        </span>
        <span>{prescriptions?.length || 0}</span>
      </div>

      <div className="card shadow  mt-4 mb-5 black p-2 pt-3 pb-3">
        <span className="mb-2 text-center" style={{ fontWeight: 'bold' }}>
          Information
        </span>
        <span style={{ fontSize: 'small' }}>
          <span className="information-item">Gender:</span>
          {getPatientGender()}
        </span>
        <span style={{ fontSize: 'small' }}>
          <span className="information-item">Height:</span>{' '}
          {lastPrescription?.onExaminations?.generalExaminations?.heightInfo
            ?.feet || 'n/a'}{' '}
          {lastPrescription?.onExaminations?.generalExaminations?.heightInfo
            ?.feet
            ? 'Ft '
            : ''}{' '}
          {lastPrescription?.onExaminations?.generalExaminations?.heightInfo
            ?.inch || ''}{' '}
          {lastPrescription?.onExaminations?.generalExaminations?.heightInfo
            ?.inch
            ? ' inch'
            : ''}
        </span>
        <span style={{ fontSize: 'small' }}>
          <span className="information-item">Weight:</span>{' '}
          {lastPrescription?.onExaminations?.generalExaminations?.weightInfo
            ?.weight || 'n/a'}{' '}
          {
            lastPrescription?.onExaminations?.generalExaminations?.weightInfo
              ?.weightUnit
          }
        </span>
        <span style={{ fontSize: 'small' }}>
          <span className="information-item">Blood Group:</span>{' '}
          {lastPrescription?.onExaminations?.generalExaminations?.bloodGroup ||
            'n/a'}
        </span>
        <span style={{ fontSize: 'small' }}>
          <span className="information-item">Phone Number:</span>{' '}
          {patientData?.phoneNumber || 'n/a'}
        </span>
        <span style={{ fontSize: 'small' }}>
          <span className="information-item">Last visit:</span>{' '}
          {moment(lastPrescription?.createdAt).format('Do, MMM, YYYY')}
        </span>
      </div>

      <AddPatientInfo
        patientPicture={imageContent}
        patientInfo={patientInfo}
        setPatientInfo={setPatientInfo}
        infoModal={infoModal}
        setInfoModal={setInfoModal}
        appointmentInfo={appointmentInfo}
        setAppointmentInfo={setAppointmentInfo}
        selectedOnExamination={selectedOnExamination}
        setSelectedOnExamination={setSelectedOnExamination}
        fromPage="patientHistory"
        handleSubmit={handleSubmit}
      />
    </>
  );
};

export default PatientHistoryLeft;
